export function removeCSSClass(ele, cls) {
  const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
  ele.className = ele.className.replace(reg, ' ');
}

export function addCSSClass(ele, cls) {
  ele.classList.add(cls);
}

export const toAbsoluteUrl = pathname => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = pathname.startsWith('/') ? pathname.slice(1) : pathname;
  return import.meta.env.BASE_URL + cleanPath;
};
